<template>
  <div>
    <spacer :y="5"/>
    <stack-item>
      <!-- 顧客依頼（2026-08-24）で「詳細情報」ボックスを廃し「基本情報」へ統合した。
           中身は data-grid でなくフォーム形式（旧・詳細情報側）に寄せている — Address の
           既存レイアウトをそのまま使えるため。並びは事務局サイトに合わせて
           学校名 → 学校名カナ → 住所 → 電話番号（住所が電話番号より前）。 -->
      <contents-box title="基本情報">
        <loader-simple :flag="flag.loader">
          <div v-if="!flag.loader" :class="$style.wrapper">
            <!-- 学校名・学校名カナは read-only の値表示（編集対象は住所・電話番号だけ）。
                 schoolItems へ足すと updateBase の payload に載って name/kana まで
                 書き換えに行くため、この 2 行は静的行のまま置く。 -->
            <div :class="$style.row">
              <div :class="$style.label_wrap">
                <!-- 値は schools.name（＝サイト表示名・画面に出す名前）。当事者向けのこの画面は
                     学校/非学校の2軸で呼称を出し分ける（法人名は契約情報タブが corporate_name で出す）。
                     フォーム形式の他行が使う row.label の静的補間に倒すと企業組織で「学校名」に
                     化けるため、この 2 行だけは isCompany の動的束縛を維持する -->
                <p :class="$style.label">{{ isCompany ? '企業名' : '学校名' }}</p>
              </div>
              <spacer :y="1" />
              <div :class="$style.detail">
                <p :class="$style.readonly_value">{{ school.name }}</p>
              </div>
            </div>
            <div :class="$style.row">
              <div :class="$style.label_wrap">
                <p :class="$style.label">{{ isCompany ? '企業名カナ' : '学校名カナ' }}</p>
              </div>
              <spacer :y="1" />
              <div :class="$style.detail">
                <p :class="$style.readonly_value">{{ school.kana }}</p>
              </div>
            </div>
            <div :class="$style.row">
              <div :class="$style.label_wrap">
                <p :class="$style.label">住所</p>
              </div>
              <spacer :y="1" />
              <div class="n2br" :class="$style.detail">
                <Address
                  :items="items"
                  :isConfirm="false"
                  v-on:sendValue="receiveValue"
                  ref="address"/>
              </div>
            </div>
            <div
              :class="$style.row"
              v-for="row in schoolItems"
              :key="row.label">
              <div :class="$style.label_wrap">
                <p :class="$style.label">{{ row.label }}</p>
              </div>
              <spacer :y="1" />
              <div class="n2br" :class="$style.detail">
                <input
                  v-if="row.type === 'text'"
                  v-model="row.value"
                  type="text"
                  :class="$style.text">
              </div>
            </div>

            <btn-container>
              <basic-btn
                size="sm"
                tag="button"
                @click="updateBase">更新</basic-btn>
            </btn-container>
          </div>
        </loader-simple>
      </contents-box>
    </stack-item>
    <stack-item>
      <contents-box title="管理者情報">
        <loader-simple :flag="flag.loader">
          <data-grid v-if="!flag.loader">
            <data-row>
              <data-term width="quater">
                <label-box label="管理者"/>
              </data-term>
              <data-detail>
                <ul :class="$style.users">
                  <li
                    v-for="row in school.mainUser"
                    :key="row.id">
                    <div :class="$style.user_wrap">
                      <contents-box type="inner">
                        <div v-if="mainValues.id !== row.id">
                          <ul :class="$style.user">
                            <li
                              v-for="item in userItems"
                              :key="item.name"
                              v-show="item.name !== 'kana'">
                              <p :class="$style.user_value" v-if="getMainUserField(row, item.name)">
                                <i :class="item.icon"/>
                                <span v-if="item.isSchoolAdminField">{{ item.label }}: </span>
                                {{ getMainUserField(row, item.name) }}<span v-if="item.name === 'username' && row.kana">（{{ row.kana }}）</span>
                              </p>
                              <p :class="$style.user_value" v-else><i :class="item.icon"/>登録なし</p>
                            </li>
                          </ul>
                          <spacer :y="2"/>
                          <btn-container align="right">
                            <basic-btn
                              v-if="row.id === user.id"
                              tag="button"
                              size="sm"
                              v-on:click="editStart(row, 'main')">編集</basic-btn>
                          </btn-container>
                        </div>
                        <div v-else>
                          <ul>
                            <li
                              v-for="item in userItems"
                              :key="item.name">
                              <div :class="$style.label_wrap">
                                <p :class="$style.label">{{ item.label }}<span v-if="item.required" :class="$style.required">※必須</span></p>
                              </div>
                              <div :class="$style.detail">
                                <input
                                  v-if="item.name === 'email'"
                                  id="mainUser"
                                  type="email"
                                  name="mainUser"
                                  v-model.trim="$v.mainUser.$model"
                                  v-model="mainValues[item.name]"
                                  :class="$style.text">
                                <input
                                  v-else-if="item.name === 'kana'"
                                  type="text"
                                  v-model.trim="mainValues[item.name]"
                                  @compositionend="onUserKanaBlur('main')"
                                  @blur="onUserKanaBlur('main')"
                                  :class="$style.text">
                                <input
                                  v-else
                                  type="text"
                                  v-model="mainValues[item.name]"
                                  :placeholder="item.isSchoolAdminField ? item.placeholder : ''"
                                  :class="$style.text">
                                <p v-if="item.name === 'email'
                                  && $v.mainUser.$dirty
                                  && $v.mainUser.email.$invalid"
                                  :class="$style.validation">正しいメールアドレスの形式で入力してください</p>
                                <p v-if="item.name === 'kana' && mainKanaInvalid"
                                  :class="$style.validation">カナ文字のみ入力してください</p>
                              </div>
                            </li>
                          </ul>
                          <spacer :y="2"/>
                          <btn-container>
                            <basic-btn
                              tag="button"
                              size="sm"
                              v-on:click="updateUser('main')">更新</basic-btn>
                            <spacer :x="2"/>
                            <basic-btn
                              tag="button"
                              size="sm"
                              type="bdr"
                              v-on:click="editCancel('main')">戻る</basic-btn>
                          </btn-container>
                          <spacer :y="2"/>
                          <div :class="$style.editpassword" v-if="row.id === user.id">
                            <router-link to="/edit/password/">パスワードの変更はこちら</router-link>
                          </div>
                        </div>
                      </contents-box>
                    </div>
                  </li>
                </ul>
              </data-detail>
            </data-row>
            <data-row>
              <data-term width="quater">
                <label-box label="副管理者"/>
              </data-term>
              <data-detail>
                <p :class="$style.helper_text">※ 副管理者は最大 {{ subAdminLimit }} 名まで登録できます</p>
                <ul :class="$style.users">
                  <li
                    v-for="row in mergedSubUsers"
                    :key="`${row._source}-${row.id}`">
                    <div :class="$style.user_wrap">
                      <contents-box type="inner">
                        <div v-if="editingSubKey !== `${row._source}-${row.id}`">
                          <ul :class="$style.user">
                            <li
                              v-for="item in userItems"
                              :key="item.name"
                              v-show="item.name !== 'kana' && !(item.isSchoolAdminField && row._source === 'subUsers') && !(item.name === 'department' && row._source === 'users' && isSubDepartmentHidden)">
                              <p :class="$style.user_value" v-if="row[item.name]">
                                <i :class="item.icon"/>
                                <span v-if="item.isSchoolAdminField">{{ item.label }}: </span>
                                {{ row[item.name] }}<span v-if="item.name === 'username' && row.kana">（{{ row.kana }}）</span>
                                <span
                                  v-if="item.name === 'username' && !isSubSchoolAdmin"
                                  :class="$style.status_badge_wrap">
                                  <span :class="[$style.status_badge, $style[`status_${row.loginStatus}`]]">{{ loginStatusLabel(row.loginStatus) }}</span>
                                  <span :class="$style.status_hint">
                                    <i class="fa-regular fa-circle-question" :class="$style.status_hint_icon"></i>
                                    <span :class="$style.status_tooltip">{{ loginStatusDetail(row.loginStatus) }}</span>
                                  </span>
                                </span>
                              </p>
                              <p :class="$style.user_value" v-else>
                                <i :class="item.icon"/>登録なし
                                <span
                                  v-if="item.name === 'username' && !isSubSchoolAdmin"
                                  :class="$style.status_badge_wrap">
                                  <span :class="[$style.status_badge, $style[`status_${row.loginStatus}`]]">{{ loginStatusLabel(row.loginStatus) }}</span>
                                  <span :class="$style.status_hint">
                                    <i class="fa-regular fa-circle-question" :class="$style.status_hint_icon"></i>
                                    <span :class="$style.status_tooltip">{{ loginStatusDetail(row.loginStatus) }}</span>
                                  </span>
                                </span>
                              </p>
                            </li>
                          </ul>
                          <spacer :y="2"/>
                          <btn-container align="right">
                            <basic-btn
                              v-if="isMainSchoolAdmin || row.id === user.id"
                              tag="button"
                              size="sm"
                              v-on:click="editStart(row, 'sub')">編集</basic-btn>
                            <template v-if="isMainSchoolAdmin && (row._source === 'subUsers' || (row._source === 'users' && !row.has_password))">
                              <spacer :x="2"/>
                              <basic-btn
                                tag="button"
                                size="sm"
                                type="bdr"
                                v-on:click="sendPasswordSetupLink(row)">ログイン有効化リンクを送信</basic-btn>
                            </template>
                          </btn-container>
                          <template v-if="isMainSchoolAdmin && (row._source === 'subUsers' || (row._source === 'users' && !row.has_password)) && row.last_link_sent_at">
                            <p :class="$style.last_link_sent">前回送信: {{ row.last_link_sent_at }}</p>
                          </template>
                        </div>
                        <div v-else>
                          <ul>
                            <li
                              v-for="item in subUserItems"
                              :key="item.name"
                              v-show="!(item.isSchoolAdminField && subValues._source === 'subUsers')">
                              <div :class="$style.label_wrap">
                                <p :class="$style.label">{{ item.label }}<span v-if="item.required && !isLockedSelfField(item.name)" :class="$style.required">※必須</span></p>
                              </div>
                              <div :class="$style.detail">
                                <!-- 副管理者が自分自身を編集する経路では氏名/カナ/メールを編集不可（read-only テキスト表示）にする。
                                     主管理者が副管理者を編集する経路は isSubSelfEdit=false のため従来どおり全項目編集可。 -->
                                <p v-if="isLockedSelfField(item.name)" :class="$style.readonly_value">{{ subValues[item.name] }}</p>
                                <template v-else>
                                  <input
                                    v-if="item.name === 'email'"
                                    id="subUser"
                                    type="email"
                                    name="subUser"
                                    v-model.trim="$v.subUser.$model"
                                    v-model="subValues[item.name]"
                                    :class="$style.text">
                                  <input
                                    v-else-if="item.name === 'kana'"
                                    type="text"
                                    v-model.trim="subValues[item.name]"
                                    @compositionend="onUserKanaBlur('sub')"
                                    @blur="onUserKanaBlur('sub')"
                                    :class="$style.text">
                                  <input
                                    v-else
                                    type="text"
                                    v-model="subValues[item.name]"
                                    :placeholder="item.isSchoolAdminField ? item.placeholder : ''"
                                    :class="$style.text">
                                  <p v-if="item.name === 'email'
                                    && $v.subUser.$dirty
                                    && $v.subUser.email.$invalid"
                                    :class="$style.validation">正しいメールアドレスの形式で入力してください</p>
                                  <p v-if="item.name === 'kana' && subKanaInvalid"
                                    :class="$style.validation">カナ文字のみ入力してください</p>
                                </template>
                              </div>
                            </li>
                          </ul>
                          <!-- レガシー subUsers は職階(schoolAdmins)の保存先を持たないため、ログイン有効化リンク送信(=users移管)後にのみ設定可能 -->
                          <p v-if="subValues._source === 'subUsers'" :class="$style.last_link_sent">{{ schoolAdminFieldsLabel }}はログイン有効化リンクを送信後に設定できます。</p>
                          <!-- 重複等のエラーは編集中フォーム内に表示し、どの副管理者のエラーか紐付ける -->
                          <p v-if="subErrorMessage" :class="$style.validation">{{ subErrorMessage }}</p>
                          <spacer :y="2"/>
                          <btn-container>
                            <basic-btn
                              tag="button"
                              size="sm"
                              v-on:click="updateUser('sub')">更新</basic-btn>
                            <spacer :x="2"/>
                            <basic-btn
                              tag="button"
                              size="sm"
                              type="bdr"
                              v-on:click="editCancel('sub')">戻る</basic-btn>
                            <template v-if="isMainSchoolAdmin">
                              <spacer :x="2"/>
                              <basic-btn
                                tag="button"
                                size="sm"
                                addClass="danger"
                                v-on:click="deleteSubUser('sub')">削除</basic-btn>
                            </template>
                          </btn-container>
                          <spacer :y="2" v-if="row.id === user.id"/>
                          <div :class="$style.editpassword" v-if="row.id === user.id">
                            <router-link to="/edit/password/">パスワードの変更はこちら</router-link>
                          </div>
                        </div>
                      </contents-box>
                    </div>
                  </li>
                  <li v-if="isMainSchoolAdmin && !subAdminLimitReached">
                    <div :class="$style.user_wrap">
                      <contents-box type="inner">
                        <div v-if="!flag.registSubUser">
                          <basic-btn
                            tag="button"
                            size="sm"
                            v-on:click="editStart(null, 'sub')">副管理者を追加</basic-btn>
                        </div>
                        <div v-else>
                          <ul>
                            <li
                              v-for="item in subUserItems"
                              :key="item.name">
                              <div :class="$style.label_wrap">
                                <p :class="$style.label">{{ item.label }}<span v-if="item.required" :class="$style.required">※必須</span></p>
                              </div>
                              <div :class="$style.detail">
                                <input
                                  v-if="item.name === 'kana'"
                                  type="text"
                                  v-model.trim="subValues[item.name]"
                                  @compositionend="onUserKanaBlur('sub')"
                                  @blur="onUserKanaBlur('sub')"
                                  :class="$style.text">
                                <input
                                  v-else
                                  type="text"
                                  v-model="subValues[item.name]"
                                  :placeholder="item.isSchoolAdminField ? item.placeholder : ''"
                                  :class="$style.text">
                                <p v-if="item.name === 'kana' && subKanaInvalid"
                                  :class="$style.validation">カナ文字のみ入力してください</p>
                              </div>
                            </li>
                          </ul>
                          <!-- 重複等のエラーは追加中フォーム内に表示し、入力値を保持したまま訂正できるようにする -->
                          <p v-if="subErrorMessage" :class="$style.validation">{{ subErrorMessage }}</p>
                          <spacer :y="2"/>
                          <btn-container>
                            <basic-btn
                              tag="button"
                              size="sm"
                              v-on:click="updateUser('sub')">登録</basic-btn>
                            <spacer :x="2"/>
                            <basic-btn
                              tag="button"
                              size="sm"
                              type="bdr"
                              v-on:click="editCancel('sub')">戻る</basic-btn>
                          </btn-container>
                        </div>
                      </contents-box>
                    </div>
                  </li>
                </ul>
              </data-detail>
            </data-row>
          </data-grid>
        </loader-simple>
      </contents-box>
    </stack-item>
    <spacer :y="5"/>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import moment from 'moment';
import cf from '@/mixins/commonFunctions';
import saf from '@/mixins/schoolAdminFunctions';
import { normalizeKana, isValidKana } from '@/lib/normalizeKana';
import BasicBtn from '@/views/components/BasicBtn.vue';
import BtnContainer from '@/views/components/BtnContainer.vue';
import StackItem from '@/views/components/StackItem.vue';
import ContentsBox from '@/views/components/ContentsBox.vue';
import LabelBox from '@/views/components/LabelBox.vue';
import LoaderSimple from '@/views/components/LoaderSimple.vue';
import Spacer from '@/views/components/Spacer.vue';
import { Address } from '@/views/components/parts/Form';
import { useVuelidate } from '@vuelidate/core';
import { email } from '@vuelidate/validators';
import { ref } from 'vue';
import {
  DataGrid, DataRow, DataTerm, DataDetail,
} from '@/views/components/DataGrid';

export default {
  name: 'account',
  components: {
    BasicBtn,
    BtnContainer,
    StackItem,
    ContentsBox,
    LabelBox,
    LoaderSimple,
    Spacer,
    Address,
    DataGrid,
    DataRow,
    DataTerm,
    DataDetail,
  },
  mixins: [cf, saf],
  computed: {
    ...mapState(['user', 'helper']),
    /** 非学校（インターン/企業）か。基本情報の呼称を「学校名/企業名」で出し分けるための2軸判定。
     *  3区分（学校/インターン/企業）でなく is_company 単独で見るのは、インターンも呼称は「企業名」だから
     *  （corporateSchool mixin の orgTypeOf は企業固有動作のゲート用で、呼称の軸とは別）。
     *  所属校未ロード/未所属でも落ちないよう optional chaining で読む。 */
    isCompany() {
      return Boolean(this.user?.school?.[0]?.is_company);
    },
    /** サイト種別に応じて表示する schoolAdmins 項目（mixin 由来・種別により列数可変）。
     *  フォーム用に icon/required/isSchoolAdminField を付与（物理列順 department→position→role） */
    schoolAdminFields() {
      const school = this.user && this.user.school && this.user.school[0];
      return this.schoolAdminFieldDefs(
        school && school.is_company,
        school && school.school_type,
      ).map((f) => ({
        ...f,
        icon: 'fa-solid fa-briefcase',
        required: true,
        isSchoolAdminField: true,
      }));
    },
    /** 表示列のラベルを「・」で連結（レガシー subUsers 案内文用） */
    schoolAdminFieldsLabel() {
      return this.schoolAdminFields.map((field) => field.label).join('・');
    },
    /** 副管理者(account_type=12)用の表示列定義。school 種別（小中高/フリースクール/個人）では所属を出さず、
     *  company/university では従来どおり所属を表示する（主管理者用の schoolAdminFields とは別 computed）。 */
    schoolAdminFieldsSub() {
      const school = this.user && this.user.school && this.user.school[0];
      return this.schoolAdminFieldDefs(
        school && school.is_company,
        school && school.school_type,
        12,
      );
    },
    /** 副管理者で所属(department)列が非表示か（school 種別の副では true）。副フォーム・副一覧の所属行出し分けに使う */
    isSubDepartmentHidden() {
      return !this.schoolAdminFieldsSub.some((field) => field.name === 'department');
    },
    /** ユーザー入力項目（固定3項目 + サイト種別依存の schoolAdmins 項目）。
     *  氏名ラベルは組織の管理者/副管理者/契約担当者を扱う全画面（登録・更新・本画面）で
     *  「氏名」に統一する（利用者・カウンセラーは別エンティティのため従来どおり「名前」）。 */
    userItems() {
      return [
        {
          label: '氏名', name: 'username', icon: 'fa-solid fa-user', required: true,
        },
        {
          label: 'カナ', name: 'kana', icon: '', required: true,
        },
        {
          label: 'メールアドレス', name: 'email', icon: 'fa-regular fa-envelope', required: true,
        },
        ...this.schoolAdminFields,
      ];
    },
    /** 副管理者フォーム用の入力項目。school 種別の副では所属(department)行を除外（schoolAdminFieldsSub 由来）。
     *  company/university では所属も必須（schoolAdminFields の required:true を継承・school 種別は所属行自体が出ない）。
     *  職階/役割は従来どおり必須。※必須マーク表示はこの required に従う。 */
    subUserItems() {
      const subKeys = this.schoolAdminFieldsSub.map((field) => field.name);
      return this.userItems
        .filter((item) => !item.isSchoolAdminField || subKeys.includes(item.name));
    },
    /** 副管理者の最大登録数 */
    subAdminLimit() {
      return 4;
    },
    /**
     * 副管理者一覧（subUsers 由来 + users (account_type=12) 由来 を統合）
     * 各行に `_source` を付与してフロント側で経路分岐可能にする
     */
    mergedSubUsers() {
      const rows = [];
      const now = moment();
      if (this.school && Array.isArray(this.school.subUser)) {
        this.school.subUser.forEach((s) => {
          // バックエンドのリレーション側で flag=1 AND migrated=0 のみに絞っているが念のため二重ガード
          if (s.flag !== 999 && Number(s.migrated) !== 1) {
            rows.push({
              id: s.id,
              username: s.username,
              kana: s.kana,
              email: s.email,
              department: null,
              position: null,
              role: null,
              has_password: false, // subUsers レコードは常に未設定
              last_link_sent_at: null, // subUsers 由来は未送信状態でのみ表示される
              // subUsers 由来は「ログイン有効化リンク未送信（通知メールのみ運用）」→ not_sent と同表示
              loginStatus: 'not_sent',
              _source: 'subUsers',
            });
          }
        });
      }
      if (this.school && Array.isArray(this.school.schoolAdmins)) {
        this.school.schoolAdmins.forEach((a) => {
          const u = a.user;
          if (u && Number(u.account_type) === 12 && Number(u.flag) === 1) {
            // has_password はバックエンドで注入される（password 自体は hidden で露出しない）
            const hasPassword = !!u.has_password;
            // ログイン状態の派生:
            //   available: password 設定済み → ログイン可能
            //   pending:   リンク送信済・期限内（activatekey 有効）
            //   expired:   リンク送信済・期限切れ（要再送）
            //   not_sent:  未送信（users 作成直後、expiry=NULL）
            let loginStatus;
            if (hasPassword) loginStatus = 'available';
            else if (u.expiry && moment(u.expiry).isAfter(now)) loginStatus = 'pending';
            else if (u.expiry) loginStatus = 'expired';
            else loginStatus = 'not_sent';
            rows.push({
              id: u.id,
              username: u.username,
              kana: u.kana,
              email: u.email,
              department: a.department || null,
              position: a.position || null,
              role: a.role || null,
              has_password: hasPassword,
              // expiry は activatekey 発行時に「now + 1 day」で設定されるため、expiry − 1 日 = 前回送信時刻
              last_link_sent_at: u.expiry ? moment(u.expiry).subtract(1, 'days').format('YYYY/MM/DD HH:mm') : null,
              loginStatus,
              _source: 'users',
            });
          }
        });
      }
      return rows;
    },
    subAdminLimitReached() {
      return this.mergedSubUsers.length >= this.subAdminLimit;
    },
    /** 自分自身が学校管理者か（主=11）。副管理者(12)は他副管理者を編集できない */
    isMainSchoolAdmin() {
      return this.user && Number(this.user.account_type) === 11;
    },
    /** 閲覧者が副管理者(12)か。副管理者には同校管理者のログインステータスバッジを見せない(#4) */
    isSubSchoolAdmin() {
      return this.user && Number(this.user.account_type) === 12;
    },
    /** 副管理者(12)が自分自身を編集中か。氏名/カナ/メールを read-only 表示にして自己編集をロックする判定に使う。
     *  主管理者(11)が副管理者を編集する経路は isSubSchoolAdmin=false のためロックされない（全項目編集可を維持）。 */
    isSubSelfEdit() {
      return this.isSubSchoolAdmin && this.subValues && this.subValues.id === this.user.id;
    },
  },
  data() {
    return {
      mainKanaInvalid: false,
      subKanaInvalid: false,
      flag: {
        loader: true,
        readySubmit: false,
        registSubUser: false,
      },
      validationFlags: {
        mainUser: false,
        subUser: false,
      },
      invalids: {
        mainUser: true,
        subUser: true,
      },
      school: null,
      schoolItems: [
        {
          label: '電話番号',
          name: 'tel',
          type: 'text',
          value: null,
        },
      ],
      items: [
        {
          name: 'zip',
          type: 'text',
          label: '郵便番号',
          value: null,
          required: true,
          placeholder: '1020074',
          comment: '半角・ハイフンなしで入力してください',
        },
        {
          name: 'pref',
          type: 'select',
          label: '都道府県',
          value: null,
          options: [],
          required: true,
          comment: '',
        },
        {
          name: 'city',
          type: 'text',
          label: '市区町村',
          value: null,
          required: true,
          placeholder: '千代田区九段南',
        },
      ],
      address: null,
      mainValues: {
        id: null,
        username: null,
        kana: null,
        email: null,
        department: null,
        position: null,
        role: null,
      },
      // 編集中の副管理者の作業領域（_source で users / subUsers 経路を分岐）
      subValues: {
        id: null,
        username: null,
        kana: null,
        email: null,
        department: null,
        position: null,
        role: null,
        _source: null, // 'users' (account_type=12) or 'subUsers' (legacy)
      },
      // 編集中の副管理者キー（_source + id の組）。null なら非編集
      editingSubKey: null,
      // 副管理者操作のエラー表示（email 衝突等）
      subErrorMessage: null,
    };
  },
  setup() {
    const mainUser = ref('');
    const subUser = ref('');

    const rules = {
      mainUser: { email },
      subUser: { email },
    };

    const $v = useVuelidate(rules, {
      mainUser,
      subUser,
    });

    return { mainUser, subUser, $v };
  },
  created() {
    if (this.user.email) {
      this.getSchool();
    } else {
      this.$store.subscribe((mutation) => {
        if (mutation.type === 'user/setUserData') {
          this.getSchool();
        }
      });
    }
    if (this.helper.master.prefs) {
      this.items[1].options = this.helper.master.prefs;
    } else {
      this.$store.subscribe((mutations) => {
        if (mutations.type === 'helper/putMaster') {
          this.items[1].options = mutations.payload.prefs;
        }
      });
    }
  },
  watch: {
    user: {
      handler() {
        this.getSchool();
      },
      deep: true,
    },
  },
  methods: {
    /** ログインステータスのラベル文言（loginStatus → 表示文字列） */
    loginStatusLabel(status) {
      return ({
        available: 'ログイン可能',
        pending: '本人によるパスワード設定待ち',
        expired: 'リンク期限切れ・要再送',
        not_sent: 'リンク未送信',
      })[status] || '';
    },
    /** ログインステータスの詳細説明（ツールチップ表示用） */
    loginStatusDetail(status) {
      return ({
        available: 'パスワード設定済みで、本人がログインできる状態です。',
        pending: 'ログイン有効化リンクを送信済みです。本人がパスワードを設定するとログイン可能になります。',
        expired: '送信したログイン有効化リンクの有効期限が切れています。リンクを再送してください。',
        not_sent: 'ログイン有効化リンクが未送信です。リンクを送信すると本人がパスワードを設定できます。',
      })[status] || '';
    },
    /** ローディング表示 */
    showLoading() {
      const args = { modalName: 'modalLoadingBallScaleRippleMultiple' };
      this.$store.dispatch('modal/loadings/showModal', args, { root: true });
    },
    /** ローディング非表示 */
    hideLoading() {
      this.$store.dispatch('modal/loadings/hideModal', null, { root: true });
    },
    /** 子から値を受け取る */
    receiveValue(values) {
      this.flag.readySubmit = values.readySubmit;
      this.address = values.address;
    },
    /** 主/副管理者 kana: IME 確定後・blur 時に normalize（入力アシスト） */
    onUserKanaBlur(name) {
      const values = this[`${name}Values`];
      const normalized = normalizeKana(values.kana);
      values.kana = normalized;
      this[`${name}KanaInvalid`] = !!normalized && !isValidKana(normalized);
    },
    getSchool() {
      this.school = this.user.school[0];
      // 電話番号をセット（組織のメールアドレスは顧客依頼で撤去。列とデータは残置し、
      // 送信 payload にも載せないので既存値はそのまま保持される）
      this.schoolItems.forEach((elem) => {
        if (elem.name === 'tel') elem.value = this.school.tel;
      });
      this.flag.loader = false;
      if (this.school.address) {
        setTimeout(() => {
          this.$refs.address.setCustomerData(this.school.address);
        }, 1000);
      }
    },
    /** 主管理者の schoolAdmins 行を取得（department/position/role 引き用） */
    getMainSchoolAdmin(userId) {
      if (!this.school || !Array.isArray(this.school.schoolAdmins)) return null;
      return this.school.schoolAdmins.find((a) => a.user_id === userId) || null;
    },
    /** 主管理者表示の各フィールドを取得（所属/職階/役割は schoolAdmins から引く） */
    getMainUserField(row, fieldName) {
      if (fieldName === 'department' || fieldName === 'position' || fieldName === 'role') {
        const matched = this.getMainSchoolAdmin(row.id);
        return matched ? matched[fieldName] : null;
      }
      return row[fieldName];
    },
    /** 自己編集ロック対象フィールドか（副管理者の自己編集時のみ氏名/カナ/メールを read-only 化）。
     *  ※必須マーク抑止と input→read-only テキスト差し替えの両方で使う。 */
    isLockedSelfField(name) {
      return this.isSubSelfEdit && ['username', 'kana', 'email'].includes(name);
    },
    editStart(target, name) {
      this.subErrorMessage = null;
      if (name === 'sub') {
        if (!target) {
          this.editCancel('sub');
          this.flag.registSubUser = true;
          this.editingSubKey = null;
          this.subValues = {
            id: null, username: null, kana: null, email: null, department: null, position: null, role: null, _source: 'users',
          };
          return;
        }
        this.flag.registSubUser = false;
        this.editingSubKey = `${target._source}-${target.id}`;
        this.subValues = {
          id: target.id,
          username: target.username,
          kana: target.kana,
          email: target.email,
          department: target.department,
          position: target.position,
          role: target.role,
          _source: target._source,
        };
        return;
      }
      // name === 'main'
      this.flag.registSubUser = false;
      const matched = this.getMainSchoolAdmin(target.id);
      this.mainValues = {
        id: target.id,
        username: target.username,
        kana: target.kana,
        email: target.email,
        department: matched ? matched.department : null,
        position: matched ? matched.position : null,
        role: matched ? matched.role : null,
      };
    },
    editCancel(name) {
      this.subErrorMessage = null;
      this.flag.registSubUser = false;
      if (name === 'sub') {
        this.editingSubKey = null;
        this.subValues = {
          id: null, username: null, kana: null, email: null, department: null, position: null, role: null, _source: null,
        };
        return;
      }
      this.mainValues = {
        id: null, username: null, kana: null, email: null, department: null, position: null, role: null,
      };
    },
    updateBase() {
      if (!this.flag.readySubmit) {
        alert('住所を正しく入力してください。');
        return;
      }
      this.showLoading();
      const data = {
        id: this.school.id,
      };
      this.schoolItems.forEach((row) => {
        data[row.name] = row.value;
      });

      this.axios({
        method: 'POST',
        url: '/v1/school/set/updater',
        data,
      })
        .then(() => {
          this.updateAddress();
        })
        .catch((error) => {
          if (error.message) console.log(error.message);
          else console.log(error);
          // バックエンドのバリデーションエラー（フリガナ等）メッセージがあれば表示
          const serverMessage = error.response && error.response.data && error.response.data.message;
          alert(serverMessage || '学校情報の更新に失敗しました。');
          this.hideLoading();
        });
    },
    updateAddress() {
      const data = this.address;
      data.id = this.school.address ? this.school.address.id : null;

      const endpoint = data.id ? 'updater' : 'register';

      if (!data.id) {
        data.model_type = 2;
        data.foreign_id = this.school.id;
      }

      this.axios({
        method: 'POST',
        url: `/v1/address/set/${endpoint}`,
        data,
      })
        .then(() => {
          alert('更新が完了しました。');
          // 先に store を最新化してから getSchool() で再バインドする。
          // store が旧値のままだと getSchool() が旧値で入力欄を上書きし revert して見える。
          return this.$store.dispatch('user/update');
        })
        .then(() => {
          this.getSchool();
          this.hideLoading();
        })
        .catch((error) => {
          if (error.message) console.log(error.message);
          else console.log(error);
          this.hideLoading();
        });
    },
    updateUser(name) {
      this.subErrorMessage = null;
      this.showLoading();
      const values = this[`${name}Values`];
      const data = { ...values };
      const isMain = name === 'main';
      const url = isMain ? 'user' : 'user/sub';
      // 副管理者更新は新規(register) or 更新(update) を id 有無で判定
      const endpoint = data.id ? 'update' : 'register';
      const label = data.id ? '更新' : '登録';
      if (!data.username || data.username === '') {
        alert('氏名を入力してください');
        this.hideLoading();
        return;
      }
      if (!data.kana || data.kana === '') {
        alert(isMain ? '管理者カナを入力してください。' : '副管理者カナを入力してください。');
        this.hideLoading();
        return;
      }
      if (data.kana && !isValidKana(data.kana)) {
        alert('カナは全角カタカナで入力してください。ユーザ管理画面で訂正後再度更新してください。');
        this.hideLoading();
        return;
      }
      if (!data.email || data.email === '') {
        alert(isMain ? 'メールアドレスを入力してください。' : '副管理者メールアドレスを入力してください。');
        this.hideLoading();
        return;
      }
      // レガシー subUsers 由来の編集は所属/職階/役割の保存先(schoolAdmins)を持たず、移管後にのみ設定可能なため必須にしない
      // （BE 側でも subUsers 分岐で department/position/role は無視される）。
      // 必須対象はサイト種別で表示中の列（非表示列は送信直前に null 化して BE で null 保存）。
      if (data._source !== 'subUsers') {
        // 主管理者は schoolAdminFields（全列）、副管理者は schoolAdminFieldsSub（company/university は所属含む3列必須・
        // school 種別は所属を出さず職階/役割のみ必須）。所属は表示される種別では主/副とも必須。
        const requiredFields = isMain
          ? this.schoolAdminFields
          : this.schoolAdminFieldsSub;
        const missingField = requiredFields.find((field) => !data[field.name] || data[field.name] === '');
        if (missingField) {
          alert(`${missingField.label}を入力してください。`);
          this.hideLoading();
          return;
        }
      }
      if (!data.id) data.school_id = this.user.school[0].id;
      if (isMain) {
        // 主管理者は account_type=11 の users 経路で所属/職階/役割を更新するため _source=users 固定
        data._source = 'users';
      }
      // 非表示の所属/職階/役割 列は null で送る（学校タイプ切替などで取り残された旧値を DB に残さない）。
      // 副管理者(12)は school 種別で所属も非表示になるため accountType を渡して null 化対象を揃える。
      const adminSchool = this.user && this.user.school && this.user.school[0];
      this.clearHiddenSchoolAdminFields(data, adminSchool && adminSchool.is_company, adminSchool && adminSchool.school_type, isMain ? 11 : 12);

      this.axios({
        method: 'POST',
        url: `/v1/${url}/set/${endpoint}`,
        data,
      })
        .then((response) => {
          const res = response.data;
          if (res.duplicate) {
            // 重複時はフォームを閉じず（editCancel/getSchool しない）、入力値を保持したまま
            // フォーム内にエラーを表示して、その場でメールアドレスを訂正・再送信できるようにする。
            // メッセージは BE が temporary で出し分けた仮登録/本登録文言（res.message）を表示する。
            this.subErrorMessage = res.message;
            this.hideLoading();
            return;
          }
          alert(`${label}が完了しました。`);
          this.$store.dispatch('user/update');
          this.getSchool();
          this.editCancel(name);
          this.hideLoading();
        })
        .catch((error) => {
          const status = error.response && error.response.status;
          const serverMessage = error.response && error.response.data && error.response.data.message;
          if (!isMain && (status === 409 || status === 422)) {
            this.subErrorMessage = serverMessage || `${label}に失敗しました。`;
          } else {
            alert(serverMessage || `${label}に失敗しました。`);
          }
          if (error.message) console.log(error.message);
          else console.log(error);
          this.hideLoading();
        });
    },

    deleteSubUser() {
      const userData = this.subValues;
      // eslint-disable-next-line no-restricted-globals, no-alert
      const ok = confirm(`${userData.username} さんを副管理者から削除します。この操作は取り消せません。よろしいですか？`);
      if (!ok) return;
      this.showLoading();
      const data = {
        id: userData.id,
        flag: 999,
        _source: userData._source,
      };
      this.axios({
        method: 'POST',
        url: '/v1/user/sub/set/update',
        data,
      })
        .then(() => {
          alert('副管理者の削除が完了しました');
          this.getSchool();
          this.editCancel('sub');
          this.$store.dispatch('user/update');
          this.hideLoading();
        })
        .catch((error) => {
          if (error.message) console.log(error.message);
          else console.log(error);
          alert('副管理者の削除に失敗しました。お手数ですが管理者までお知らせください');
          this.hideLoading();
        });
    },

    /** ログイン有効化リンク送信（PW 設定リンクを送信して副管理者のログインを有効化する） */
    sendPasswordSetupLink(row) {
      // eslint-disable-next-line no-restricted-globals, no-alert
      const ok = confirm(`${row.username} さんにログイン有効化リンクを送信します。よろしいですか？`);
      if (!ok) return;
      this.subErrorMessage = null;
      this.showLoading();
      this.axios({
        method: 'POST',
        url: '/v1/user/sub/set/sendPasswordSetupLink',
        data: {
          id: row.id,
          _source: row._source,
        },
      })
        .then(() => {
          alert('ログイン有効化リンクを送信しました');
          this.$store.dispatch('user/update');
          this.getSchool();
          this.hideLoading();
        })
        .catch((error) => {
          const serverMessage = error.response && error.response.data && error.response.data.message;
          // この処理はリスト行のボタンから呼ばれ編集フォームを開いていないため、
          // subErrorMessage（フォーム内表示）では表示先が無く失敗が見えなくなる。
          // 重複エラーのフォーム内表示とは別経路として、失敗は alert で通知する。
          alert(serverMessage || 'ログイン有効化リンクの送信に失敗しました。');
          if (error.message) console.log(error.message);
          else console.log(error);
          this.hideLoading();
        });
    },
  },
};
</script>

<style lang="scss" module>
.users {
  margin-top: -20px;
}
.user {
  &_wrap {
    margin-top: 20px;
  }
  li {
    &:not(:first-child) {
      margin-top: 12px;
    }
  }
  &_value {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    i {
      margin-right: 12px;
      color: var(--orange-main);
    }
  }
}
.row {
  padding: 24px 0;
  border-top: 1px solid var(--gray-main);
  &.child {
    border-top: none;
    &:not(:first-child) {
      padding-top: 0;
    }
  }
}
.label {
  border-radius: 4px;
  margin-right: 4px;
  font-weight: bold;
  display: inline-block;
  &_wrap {
    display: flex;
    align-items: baseline;
  }
}
.text,
.select {
  &:disabled {
    color: black;
    background-color: transparent;
    &:-webkit-autofill {
      box-shadow: 0 0 0 100px white inset;
    }
  }
}
.text,
.plane {
  width: 100%;
  padding: 13px;
  border-radius: 8px;
  background-color: var(--gray-sub);
  border: none;
  outline: none;
  $background: var(--gray-sub);
  &:-webkit-autofill {
    box-shadow: 0 0 0 100px $background inset;
  }
  &.plane {
    font-size: 14px;
    background-color: transparent;
  }
}
.readonly_value {
  // 副管理者の自己編集ロック時に input の代わりに出す read-only テキスト。
  // 入力欄(.text)と縦位置・左余白を揃えつつ、編集不可と分かるよう枠/背景は付けない。
  padding: 13px;
  color: var(--black);
  word-break: break-all;
}
.textarea {
  width: 100%;
  padding: 13px;
  border-radius: 8px;
  background-color: var(--gray-sub);
  border: none;
  outline: none;
  $background: var(--gray-sub);
  &:-webkit-autofill {
    box-shadow: 0 0 0 100px $background inset;
  }
}
.editpassword {
  display: flex;
  justify-content: center;
  a {
    font-size: 14px;
    color: var(--black);

    &:hover {
      text-decoration: underline;
    }
  }
}
.validation {
  font-size: .8em;
  color: red;
}
.helper_text {
  font-size: .85em;
  color: var(--gray-text, #666);
  margin-bottom: 8px;
}
.required {
  font-size: .75em;
  color: red;
  margin-left: 6px;
}
.last_link_sent {
  font-size: .75em;
  color: var(--gray-text, #666);
  text-align: right;
  margin-top: 8px;
  margin-bottom: 4px;
}
.status_badge_wrap {
  display: inline-flex;
  align-items: center;
  margin-left: 8px;
  vertical-align: middle;
}
.status_badge {
  display: inline-block;
  font-size: .75em;
  font-weight: bold;
  padding: 2px 8px;
  border-radius: 4px;
  white-space: nowrap;
}
// ホバーで詳細を表示する旨を `?` アイコンで明示（PJ 慣行: fa-circle-question + cursor:help）
.status_hint {
  position: relative;
  display: inline-flex;
  align-items: center;
  margin-left: 4px;
  cursor: help;
  &:hover .status_tooltip {
    visibility: visible;
    opacity: 1;
  }
}
.status_hint_icon {
  font-size: 13px;
  color: #888;
}
.status_tooltip {
  visibility: hidden;
  opacity: 0;
  position: absolute;
  bottom: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%);
  width: max-content;
  max-width: 240px;
  padding: 8px 12px;
  font-size: 12px;
  font-weight: normal;
  line-height: 1.5;
  text-align: left;
  color: #fff;
  background-color: #333;
  border-radius: 6px;
  white-space: normal;
  transition: opacity 0.2s;
  z-index: 10;
  &::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    border: 6px solid transparent;
    border-top-color: #333;
  }
}
.status_available {
  color: #fff;
  background-color: var(--green-main);
}
.status_pending {
  color: #fff;
  background-color: var(--blue-main);
}
.status_expired {
  color: #fff;
  background-color: var(--orange-main);
}
.status_not_sent {
  color: var(--black);
  background-color: var(--gray-sub);
}
</style>
